@charset "UTF-8";

/* src/app/shared/components/cta-button/cta-button.component.scss */
:host {
  display: contents;
}
.cta-button.cta-button--success {
  border-color: #0c8e1c !important;
  outline: 2px solid rgba(12, 142, 28, 0.9);
  outline-offset: 3px;
  box-shadow: 0 0 0 3px rgba(12, 142, 28, 0.2), 0 4px 22px rgba(12, 142, 28, 0.35) !important;
}
.cta-button.cta-button--success:focus,
.cta-button.cta-button--success:focus-visible {
  border-color: #0c8e1c !important;
  outline: 2px solid #0c8e1c !important;
  outline-offset: 3px !important;
  box-shadow: 0 0 0 3px rgba(12, 142, 28, 0.25), 0 4px 22px rgba(12, 142, 28, 0.35) !important;
}
.cta-success-indicator {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
  font-size: 18px;
  font-weight: 700;
  color: #0c8e1c;
  animation: cta-scale-in 0.35s ease-out, cta-pulse 1.6s 0.35s infinite;
}
.cta-button:focus-visible:not(.cta-button--success) {
  outline: 2px solid var(--action-primary, #046cea);
  outline-offset: 2px;
}
.cta-button:focus {
  outline: none;
}
@keyframes cta-scale-in {
  from {
    opacity: 0;
    transform: scale(0.4);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes cta-pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.55;
    transform: scale(1.12);
  }
}
@keyframes shake-gently {
  0%, 100% {
    transform: translate(0, 0);
  }
  20% {
    transform: translate(-4px, -2px);
  }
  40% {
    transform: translate(4px, 2px);
  }
  60% {
    transform: translate(-3px, -1px);
  }
  80% {
    transform: translate(2px, 1px);
  }
}
.shake-gently {
  animation: shake-gently 0.6s ease-in-out;
}
/*# sourceMappingURL=cta-button.component-GMVSXGOU.css.map */
